import axios from 'axios';
import {detectIE} from './util';

/** Prepare header as layer of control */
export const getHeaders = (method) => {
    /** Append header */
    const headers = {
        //Authorization: 'Bearer <<access_token>>'
        //Authorization: `f"ApiKey-v1 ${process.env.REACT_APP_AUTH_KEY}`
    };

    if (method === 'post' || method === 'put')
        headers['Content-Type'] = 'application/json';

    /** Deal with IE aggressive caching
    http://stackoverflow.com/questions/2848945/prevent-ie-caching */
    if (detectIE() && method === 'get') {
        headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
        headers['Pragma'] = 'no-cache';
        headers['Expires'] = '0';
    }

    return headers;
};


const AUTH_ERRORS = ['TOKEN_INVALID', 'AUTH_HEADER_MISSING', 'AUTH_HEADER_INVALID_FORMAT'];

// Create an Axios instance if you need. Otherwise, you can attach the interceptor to the default instance.
// const instance = axios.create();

// Use Axios's interceptor to detect errors.
axios.interceptors.response.use(
    response => {
        return response;  // if everything's good, just pass the response to the next promise chain.
    },
    error => {
        console.log('axios.interceptors.response error:', error);
        console.log('error.response:', error.response);
        console.log('error.response.data:', error.response?.data);

        const status = error.response?.status;
        const errorCode = error.response?.data?.error?.code;
        const requestUrl = error.config?.url || '';

        // Skip auth redirect for Kratos endpoints (whoami, login, logout, etc.)
        const isKratosRequest = requestUrl.includes('/auth/') || requestUrl.includes('/self-service/') || requestUrl.includes('/sessions/whoami');

        if (!isKratosRequest && (status === 401 || (errorCode && AUTH_ERRORS.includes(errorCode)))) {
            localStorage.clear();
            console.log('API intercept auth error, status:', status, 'code:', errorCode);
            window.location.href = '/login?session_expired=true';
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }
);



/** Wrap every request for additional layer of control */
export const request = (opts, responseSelector) => {
    opts.method = opts.method || 'get';
    opts.headers = getHeaders(opts.method);
    opts.withCredentials = true;
    opts.credentials = 'include';

    return axios(opts)
        .then(res => {
            //console.log('HTTP ', `${opts.method.toUpperCase()} ${opts.url}: `, res);
            return responseSelector(res);
        });
    // .catch(res => {
    //     let err = null;
    //     const response = res.response;
    //     if (response && response.data) {
    //         err = response.data;
    //     } else if (response) {
    //         err = new Error(response.statusText);
    //         err.status = response.status;
    //     } else {
    //         err = new Error(res || 'HTTP Error');
    //         err.status = 0;
    //     }
    //     console.log('HTTP ', `${opts.method} ${opts.url}: `, err, res);
    //
    //     throw res;
    // });
};

const dataResponseSelector = res => res.data;

/** Export wrapped RESTful methods */
export const get = (url, params) => request({url, params}, dataResponseSelector);
export const post = (url, data) => request({method: 'post', url, data}, dataResponseSelector);
export const put = (url, data) => request({method: 'put', url, data}, dataResponseSelector);
export const patch = (url, data) => request({method: 'patch', url, data}, dataResponseSelector);
// delete is a reserved word? so its remove instead
export const remove = (url, data) => request({method: 'delete', url, data}, dataResponseSelector);
export const delete_ = (url, data) => request({method: 'delete', url, data}, dataResponseSelector);